function initFaq() {

    let faqs = [...document.querySelectorAll('[js-hook-faq]')];
    let collapse_buttons = [...document.querySelectorAll('[js-hook-collapse]')];

    faqs.forEach(faq => {
        faq.onclick = function() {
            if(faq.classList.contains('faq--closed')){
                faq.classList.add('faq--open');
                faq.classList.remove('faq--closed');
            }
        }
    });

    collapse_buttons.forEach(button => {
        button.onclick = function(e) {
            e.stopPropagation();
            let faq = button.closest('[js-hook-faq]');
            if(faq.classList.contains('faq--open')){
                faq.classList.remove('faq--open');
                faq.classList.add('faq--closed');
            }
        }
    });

}

// Export the navigation init function
export default initFaq;



// WEBPACK FOOTER //
// /Users/sandersturing/Sites/SD/open.test/frontend/source/utilities/faq.js